module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "fx filter-wapper"
  }, [_c('div', {
    staticClass: "fx fx-wrap fx-fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "fx-shrink"
  }, [_c('z-search', {
    attrs: {
      "placeholder": "请输入手机号 / 门店名称..."
    },
    on: {
      "handleSearch": function($event) {
        return _vm.handleOffset(0)
      }
    },
    model: {
      value: (_vm.params.search),
      callback: function($$v) {
        _vm.$set(_vm.params, "search", $$v)
      },
      expression: "params.search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('z-table', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.shopList.item_total
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._l((_vm.shopList.list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": item.logo_url || _vm.defaultPic
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('p', [_vm._v("登录账号：" + _vm._s(item.tel))]), _vm._v(" "), _c('p', [_vm._v("初始密码：123456            ")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("经度：" + _vm._s(item.longitude || '未知'))]), _vm._v(" "), _c('p', [_vm._v("纬度：" + _vm._s(item.latitude || '未知'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentFmt")(item.l_time)))]), _vm._v(" "), _c('td', {
      staticClass: "operating"
    }, [_c('el-popover', {
      ref: 'pwd_popover_' + index,
      refInFor: true,
      attrs: {
        "placement": "top",
        "width": "200"
      }
    }, [_c('div', {
      staticClass: "z-popover"
    }, [_c('div', [_vm._v("确定要把此门店的POS机密码重置为初始密码123456?")]), _vm._v(" "), _c('div', {
      staticClass: "pop-btns-cont",
      on: {
        "click": function($event) {
          return _vm.handleClosePopover(index)
        }
      }
    }, [_c('a', {
      staticClass: "pop-btn-cancle"
    }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
      staticClass: "pop-btn-confirm",
      on: {
        "click": function($event) {
          return _vm.handleResetPwd(item.id)
        }
      }
    }, [_vm._v("确定")])])]), _vm._v(" "), _c('a', {
      staticClass: "operat-btn",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "icon-password"
    }), _c('span', [_vm._v("重置密码")])])]), _vm._v(" "), _c('a', {
      staticClass: "operat-btn",
      on: {
        "click": function($event) {
          return _vm.handleQrCode(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-code-simple"
    }), _c('span', [_vm._v("生成付款码")])]), _vm._v(" "), _c('router-link', {
      staticClass: "operat-btn",
      attrs: {
        "to": {
          name: 'clearInfo',
          query: {
            shopId: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-settlement"
    }), _c('span', [_vm._v("结算信息")])]), _vm._v(" "), _c('router-link', {
      staticClass: "operat-btn",
      attrs: {
        "to": {
          name: 'shopEdit',
          query: {
            shopId: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    }), _c('span', [_vm._v("编辑")])]), _vm._v(" "), _c('el-popover', {
      ref: 'popover_' + index,
      refInFor: true,
      attrs: {
        "placement": "top",
        "width": "200"
      }
    }, [_c('div', {
      staticClass: "z-popover"
    }, [_c('div', [_vm._v("删除此门店后与之相关的数据将不会显示并且门店不能恢复哟！继续删除?")]), _vm._v(" "), _c('div', {
      staticClass: "pop-btns-cont",
      on: {
        "click": function($event) {
          return _vm.handleClosePopover(index)
        }
      }
    }, [_c('a', {
      staticClass: "pop-btn-cancle"
    }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
      staticClass: "pop-btn-confirm",
      on: {
        "click": function($event) {
          return _vm.handleDeleteBtn(item.id)
        }
      }
    }, [_vm._v("确定")])])]), _vm._v(" "), _c('a', {
      staticClass: "operat-btn",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "icon-del"
    }), _c('span', [_vm._v("删除")])])])], 1)])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "operate"
    },
    slot: "operate"
  }, [_c('router-link', {
    staticClass: "z-btn z-btn-primary b-r-3",
    attrs: {
      "to": {
        name: 'shopEdit'
      }
    }
  }, [_vm._v("添加门店")])], 1)], 2)], 1), _vm._v(" "), _c('z-popup', {
    attrs: {
      "showModel": this.isPopQr
    }
  }, [_c('div', {
    staticClass: "popup-cont b-r-5",
    attrs: {
      "slot": "popup-cont"
    },
    slot: "popup-cont"
  }, [_c('p', {
    staticClass: "btn-close fx-align",
    on: {
      "click": _vm.handleCloseQrcode
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pic-cont"
  }, [_c('div', {
    attrs: {
      "id": "qrcode"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f0b3ce94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/shops/ShopManage.vue
// module id = 892
// module chunks = 0